export default __webpack_public_path__ + "static/media/snack.d19b6736.png";